import { render, staticRenderFns } from "./TagGroup.vue?vue&type=template&id=4a51fec8"
import script from "./TagGroup.vue?vue&type=script&lang=js"
export * from "./TagGroup.vue?vue&type=script&lang=js"
import style0 from "./TagGroup.vue?vue&type=style&index=0&id=4a51fec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports